var _circle, _circle2, _circle3, _circle4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCircleDot3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 575,
    height: 1134,
    viewBox: "0 0 575 1134",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 570.247,
    cy: 564.421,
    r: 421.5,
    transform: "rotate(63.8286 570.247 564.421)",
    stroke: "#7E3D64",
    strokeOpacity: 0.35,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "8 8"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 570.247,
    cy: 564.421,
    r: 378.479,
    transform: "rotate(63.8286 570.247 564.421)",
    stroke: "#7E3D64",
    strokeOpacity: 0.35,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "8 8"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 570.247,
    cy: 564.422,
    r: 334.675,
    transform: "rotate(63.8286 570.247 564.422)",
    stroke: "#7E3D64",
    strokeOpacity: 0.35,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "8 8"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 570.247,
    cy: 564.421,
    r: 290.089,
    transform: "rotate(63.8286 570.247 564.421)",
    stroke: "#7E3D64",
    strokeOpacity: 0.35,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "8 8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleDot3);
export default __webpack_public_path__ + "static/media/circle_dot3.df82582d14ecc89ccf6f25baec0379ae.svg";
export { ForwardRef as ReactComponent };